import { useRollbar } from '@rollbar/react'
import React from 'react'

import { useEnvConfig } from '../../configuration/hooks/useEnvConfig'

export const useReportError = () => {
  const { environmentName, fedrampEnabled } = useEnvConfig()
  const rollbar = useRollbar()

  return React.useCallback(
    (error, message = '', options = {}) => {
      if (environmentName === 'development') {
        return
      }

      if (fedrampEnabled) {
        window.newrelic?.noticeError(error, { message, ...options })
      } else {
        rollbar.error(error, message, options)
      }
    },
    [environmentName, fedrampEnabled, rollbar],
  )
}
